import LoginPage from './LoginPage';
import { reducer } from './reducer';

export { reducer };
export default LoginPage;
